// Region detection for global cookie/consent compliance.
// Maps ISO-3166 alpha-2 country (and optional region/state) → consent profile id.

export type ConsentRegion =
  | "EU" // GDPR + ePrivacy
  | "UK" // UK GDPR + PECR
  | "CH" // Swiss nFADP
  | "BR" // LGPD
  | "US-CA" // CCPA/CPRA
  | "US-VA" // VCDPA
  | "US-CO" // CPA
  | "US-CT" // CTDPA
  | "US-UT" // UCPA
  | "CA-QC" // Quebec Law 25
  | "ROW"; // rest of world (soft opt-in)

const EEA = new Set([
  "AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR",
  "DE", "GR", "HU", "IE", "IT", "LV", "LT", "LU", "MT", "NL",
  "PL", "PT", "RO", "SK", "SI", "ES", "SE",
  "IS", "LI", "NO",
]);

const US_OPT_OUT_STATES = new Set(["CA", "VA", "CO", "CT", "UT"]);

export function regionFromGeo(country: string | null | undefined, region: string | null | undefined): ConsentRegion {
  const c = (country || "").toUpperCase();
  const r = (region || "").toUpperCase();

  if (EEA.has(c)) return "EU";
  if (c === "GB") return "UK";
  if (c === "CH") return "CH";
  if (c === "BR") return "BR";
  if (c === "US") {
    if (r === "CA") return "US-CA";
    if (r === "VA") return "US-VA";
    if (r === "CO") return "US-CO";
    if (r === "CT") return "US-CT";
    if (r === "UT") return "US-UT";
    if (US_OPT_OUT_STATES.has(r)) return "US-CA"; // unlikely fallthrough
    return "ROW";
  }
  if (c === "CA" && r === "QC") return "CA-QC";
  return "ROW";
}

export function isOptInRegion(region: ConsentRegion): boolean {
  return region === "EU" || region === "UK" || region === "CH" || region === "BR";
}

export function isUSOptOutRegion(region: ConsentRegion): boolean {
  return region === "US-CA" || region === "US-VA" || region === "US-CO" || region === "US-CT" || region === "US-UT" || region === "CA-QC";
}
